// dashboard dialog url 地址管理
export const url = {
    getProductClicke: '/auth/dashboard/getProductClicke', // 本月点击前十产品
    getInciTrend: '/auth/dashboard/getInciTrend', // 使用趋势TOP10的成分与总计相比
    getBrandClicke: '/auth/dashboard/getBrandClicke', // 本月点击前十品牌
    getNewLaunchedClaims: '/auth/dashboard/getNewLaunchedClaims', // 年度新产品宣称分布
    getNewProducts: '/auth/dashboard/getNewProducts',  // 年度新产品数量分布
    inicFunction: '/auth/brand/inciFounction',
    yearlist: '/auth/dictionaries/findByParentId',
    goodsMarketCategory: '/auth/public/get_goodsMarketCategory',
}


// WEBPACK FOOTER //
// ./src/axios/api_urls/dashboard.js